<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>考试培训</el-breadcrumb-item>
            <el-breadcrumb-item>课程管理</el-breadcrumb-item>
            <el-breadcrumb-item>观看统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
         <div style="display:flex;justify-content: flex-end;padding:5px">
           <el-button-group style="text-align:right;display:block">
              <el-button plain @click="doFilter(2)"  :class="{cur : dataType==2}">日</el-button>
              <el-button plain @click="doFilter(0)"  :class="{cur : dataType==0}">周</el-button>
              <el-button plain @click="doFilter(1)"  :class="{cur : dataType==1}">月</el-button>
            </el-button-group>
         </div>
          <div id="container" style="min-width:100%;height:100%"></div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      groupId: '',
      dataType:'2'
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    // this.search.groupId = this.groupId
    // this.getData()
    // this.getStore()
    // this.getPerson()
    this.setChart()
  },
  methods: {
   doFilter(index){
    this.dataType = index
   },
    setChart() {
      var chart = HighCharts.chart('container', {
        chart: {
          type: 'area'
        },
        title: {
          text: '观看统计'
        },
        // subtitle: {
        //   text:
        //     '数据来源: <a href="https://thebulletin.metapress.com/content/c4120650912x74k7/fulltext.pdf">' +
        //     'thebulletin.metapress.com</a>'
        // },
        xAxis: {
             categories: ['7-1','7-2','7-3','7-4','7-5','7-6','7-7','7-8','7-9','7-10'],
          allowDecimals: false
        },
        // yAxis: {
        //   // title: {
        //   //   text: '核武库国家'
        //   // },
        //   // labels: {
        //   //   formatter: function() {
        //   //     return this.value / 1000 + 'k'
        //   //   }
        //   // }
        // },
        tooltip: {
          pointFormat: '{series.name}  <b>{point.y:,.0f}</b>人观看'
        },
        // plotOptions: {
        //   area: {
        //     pointStart: 6,
        //     marker: {
        //       enabled: false,
        //       symbol: 'circle',
        //       radius:1,
        //       states: {
        //         hover: {
        //           enabled: true
        //         }
        //       }
        //     }
        //   }
        // },
        series: [
          {
            name: '',
            data: [ 26956, 27912, 28999, 28965, 27826, 25579, 25722, 24826, 24605,24304,]
          },
          
        ]
      })
    }
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
.cur{
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color:#409EFF !important  ;
}
</style>